export enum ResourceState {
  Unchanged,
  New,
  Uploaded,
  Deleted,
  PendingUpload
}
